var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-loading"},[_c('div',{staticClass:"lottie-loader"},[_c('lottie-animation',{attrs:{"path":"lottie/dots.json"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }